import React from 'react';
import "../styles/footer.css"
import { footerRef } from '../refs';
export default function Footer() {
    return (
        <div className="fo-wrapper" ref={footerRef} >
            <div class="social-buttons" data-aos="zoom-in">
                <a href="https://www.facebook.com/profile.php?id=100015633404494" rel="noopener noreferrer" target="_blank" class="social-buttons__button social-button social-button--facebook" aria-label="Facebook">
                    <span class="social-button__inner">
                        <i class="fab fa-facebook-f"></i>
                    </span>
                </a>
                <a href="https://www.instagram.com/rupamj_das/" target="_blank" rel="noopener noreferrer" class="social-buttons__button social-button social-button--instagram" aria-label="Instagram">
                    <span class="social-button__inner">
                        <i class="fab fa-instagram"></i>
                    </span>
                </a>
                <a href="https://www.linkedin.com/in/rupam-jyoti-das-218a521a6/" rel="noopener noreferrer" target="_blank" class="social-buttons__button social-button social-button--linkedin" aria-label="LinkedIn">
                    <span class="social-button__inner">
                        <i class="fab fa-linkedin-in"></i>
                    </span>
                </a>

                <a href="https://github.com/rupam2001" target="_blank" rel="noopener noreferrer" class="social-buttons__button social-button social-button--github" aria-label="GitHub">
                    <span class="social-button__inner">
                        <i class="fab fa-github"></i>
                    </span>
                </a>
            </div>
        </div>
    )
}
